
import React, {FC, useState} from 'react';
import {Spinner} from 'react-bootstrap';
import ApptDetails, {ApptProps} from 'components/ApptDetails2';
import Button from 'components/Button';
import {useContextHolder} from 'components/useHolder/context';

import {useConfirmAppt} from './mutation';

import * as styles from './styles.module.scss';

type ConfirmApptProps = {
	appt: ApptProps
	credits: {
		count: number
		text: string
	}
	onConfirm: () => void
}

type State = {
	pending?: boolean
	error?: string
}

const ConfirmAppt: FC<ConfirmApptProps> = ({appt, credits, onConfirm}) => {
	const holder = useContextHolder();

	const [state, setState] = useState<State>({});
	const [confirm] = useConfirmAppt({
		variables: {
			appt: appt.id,
			hold: holder.id,
		},
		onCompleted: (result) => {
			const error = result.payment.reserve.error;
			if (error) {
				setState({error});
			} else {
				onConfirm();
			}
		},
		onError: () => setState({
			error: 'Sorry. We\'ve encountered a network issue. ' +
				'Please refresh the page and try again.',
		}),
	});

	return (
		<div className={styles.confirm}>
			<p>
				You have <em>{credits.text}</em> remaining.
				Would you like to use one to book this time slot?
			</p>
			<ApptDetails
				className={styles.appt}
				details={appt}
			/>
			{state.error && (
				<div className={styles.error}>
					{state.error}
				</div>
			)}
			<Button
				disabled={state.pending}
				variant='primary'
				onClick={() => {
					setState({pending: true});
					confirm();
				}}
			>
				Yes, book this time slot
				{state.pending && (
					<Spinner />
				)}
			</Button>
		</div>
	);
};

export default ConfirmAppt;
